import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import BreadCrumb from "components/Common/BreadCrumb";
import CollapseFilter from "components/Common/CollapseFilter";
import CopyWrapper from "components/Common/CopyWrapper";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import ModalPreview from "components/Common/ModalPreview";
import ModalPreviewQRCode from "components/Common/ModalPreviewQRCode";
import TableContainer from "components/Common/TableContainer";
import TooltipCustom from "components/Common/TooltipCustom";
import { useRole } from "components/Hooks/UserHooks";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import {
  COLOR_AUDITION_STATUS,
  COLOR_BAR_LIST_PARTNER_STATUS,
  COLOR_STATUS_ACTIVE_DISABLE,
  LIST_OPTION_AUDITION_STATUS,
  LIST_OPTION_BAR_LIST_PARTNER_STATUS,
  STATUS_ACTIVE_DISABLE_OPTION,
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import noImage1 from "../../assets/images/no-image.jpg";
import AuditionImg from "../../assets/images/Audition.png";
import AuditionForm from "./Form";
import BarListDetail from "./ListDetail";
import { getAuditions } from "store/audition/thunk";
import { getCompanies } from "store/thunks";
import { getFields } from "store/fields/thunk";
import auditionApi from "api/auditionApi";
import { getURLWithDomain } from "utils";
import DropdownAsyncCompanies from "components/Common/DropdownAsyncCompanies";
import CheckboxActiveAudition from "components/Common/CheckboxActiveAudition";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "created_at";
registerLocale("en", en);
registerLocale("ko", ko);

const AuditionManagement = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  
  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    title: withDefault(StringParam, ""),
    field_id: withDefault(StringParam, ""),
    active_status: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    created_from: withDefault(StringParam, ""),
    created_to: withDefault(StringParam, ""),
    company_id: withDefault(StringParam, ""),
    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, "DESC"),
  });
  const [summary, setSummary] = useState<any>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [itemToDetail, setItemToDetail] = useState<any>(null);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [isShowDetail, setIsShowDetail] = useState<boolean>(false);
  const [previewQRCode, setPreviewQRCode] = useState<any>(null);
  const [tabDetailActive, setTabDetailActive] = useState<any>("");

  const companies: any = useSelector(
    (state: any) => state?.Company?.companies?.items
  );
  const COMPANIES = useMemo(() => {
    return (
      companies?.map((item: any) => ({
        label: item?.name,
        value: item?.id,
      })) || []
    );
  }, [companies]);

  const fields: any = useSelector((state: any) => state?.Fields?.Fields?.items);
  const FIELDS = useMemo(() => {
    return (
      fields?.map((item: any) => ({
        label: item?.title,
        value: item?.id,
      })) || []
    );
  }, [fields]);

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [start_date, end_date] = dateSearch;

  const [keywordSearch, setKeywordSearch] = useState<string>(
    query?.title || ""
  );

  const [fieldSearch, setFieldSearch] = useState<Option | any>(null);
  const [companySearch, setCompanySearch] = useState<Option | any>(query?.company_id);

  const [statusSearch, setStatusSearch] = useState<Option | any>(
    STATUS_ACTIVE_DISABLE_OPTION?.find((item) => item?.value === query?.status)
      ?.value || ""
  );
  const [auditionStatusSearch, setAuditionStatusSearch] = useState<
    Option | any
  >(
    LIST_OPTION_AUDITION_STATUS?.find((item) => item?.value === query?.status)
      ?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Audition;
  const AdvertisementProperties = createSelector(
    selectLayoutState,
    (state) => ({
      auditions: state?.Auditions,
      isAuditionLoading: state?.isAuditionLoading,
      isAuditionSuccess: state?.isAuditionSuccess,
      error: state?.error,
    })
  );

  // Inside your component
  const { auditions, isAuditionLoading } = useSelector(AdvertisementProperties);

  function loadTableData() {
    dispatch(getAuditions(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      title: encodeURIComponent(keywordSearch),
      status: statusSearch,
      field_id: fieldSearch,
      company_id: (companySearch && companySearch?.value !== "all") ? companySearch?.value : "",
      active_status: auditionStatusSearch ? auditionStatusSearch == 1 : "",
      created_from: start_date
        ? formatDateStringToUTC(
            moment(new Date(start_date))
              .startOf("day")
              .format("Y-MM-DD HH:mm:ss")
          )
        : "",
      created_to: end_date
        ? formatDateStringToUTC(
            moment(new Date(end_date)).endOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        title: "",
        type: "",
        rating: "",
        plan: "",
        status: "",
        audition_status: "",
        created_from: "",
        created_to: "",
        sort_by: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setKeywordSearch((_prev) => "");
    setFieldSearch((_prev: any) => "");
    setStatusSearch((_prev: any) => "");
    setDateSearch([null, null]);
    setAuditionStatusSearch((_prev: any) => "");
    setCompanySearch((_prev: any) => "");
  };

  // Begin::Change status

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // End::Change status

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        thClass: "align-middle",
        Cell: ({ ...props }) => {
          const item = props?.row?.original;
          return (
            <CopyWrapper
              contentCopy={item?.id || ""}
              style={{ display: "inline-flex", minWidth: "60px" }}
            >
              <div>
                {auditions?.pagination?.total -
                  ((query?.page - 1) * query?.limit + props?.row?.index)}
              </div>
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("Active"),
        accessor: "is_active",
        thWidth: 80,
        // filterable: false,
        sortable: false,
        thClass: "text-center",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return <CheckboxActiveAudition item={item} />;
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        // filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "align-middle text-center",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_AUDITION_STATUS[status] || "secondary"
                }`}
              >
                {t(
                  LIST_OPTION_AUDITION_STATUS?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },

      {
        Header: t("Thumbnail"),
        accessor: "files",
        thClass: "align-middle text-center",
        // filterable: true,
        sortable: false,
        thWidth: 170,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          let thumbnailUrl =
            getURLWithDomain(item?.thumbnail_url) || AuditionImg;
          if (!thumbnailUrl) {
            const isVideo =
              item?.files?.[0]?.url && item?.files?.[0]?.type === "video";
            thumbnailUrl = isVideo
              ? item?.files?.[0]?.preview
              : item?.files?.[0]?.url;
          }

          return thumbnailUrl ? (
            <>
              <div className="w-100 text-center " style={{ minWidth: "150px" }}>
                <div
                  style={{ width: "90px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    let linkImage = item?.thumbnail_url
                      ? { url: item?.thumbnail_url }
                      : { urls: item?.files };
                    setLinkImage(linkImage);
                    document.body.className = "modal-open_img";
                  }}
                >
                  <img
                    src={thumbnailUrl}
                    className="flex-shrink-0 rounded w-100"
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = AuditionImg;
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          );
        },
      },
      {
        Header: t("photo"),
        accessor: "image_urls",
        thClass: "align-middle text-center",
        // filterable: true,
        sortable: false,
        thWidth: 170,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          let thumbnailUrl = getURLWithDomain(item?.image_urls?.[0]);
          if (!thumbnailUrl) {
            const isVideo =
              item?.files?.[0]?.url && item?.files?.[0]?.type === "video";
            thumbnailUrl = isVideo
              ? item?.files?.[0]?.preview
              : item?.files?.[0]?.url;
          }

          return thumbnailUrl ? (
            <>
              <div className="w-100 text-center " style={{ minWidth: "150px" }}>
                <div
                  style={{ width: "90px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    let linkImage = item?.thumbnail_url
                      ? { url: item?.thumbnail_url }
                      : { urls: item?.files };
                    setLinkImage(linkImage);
                    document.body.className = "modal-open_img";
                  }}
                >
                  <img
                    src={thumbnailUrl}
                    className="flex-shrink-0 rounded w-100"
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = noImage1;
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          );
        },
      },
      {
        Header: t("Title"),
        accessor: "title",
        // filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            <CopyWrapper
              contentCopy={cell?.value || ""}
              style={{
                width: "360px",
                display: "inline-flex",
                minWidth: "60px",
              }}
            >
              <div className="cursor-pointer ellipsis-2-lines">
                {cell?.value ?? "-"}
              </div>
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("company"),
        accessor: "company.name",
        // filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer" style={{ minWidth: "180px" }}>
                {cell?.value ?? "-"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("fieldCategories"),
        accessor: "role_groups",
        // filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-center",
        thWidth: 220,
        Cell: (cell: any) => {
          return (
            <div
              className="cursor-pointer d-flex align-items-center gap-1 justify-content-center"
              style={{ minWidth: "200px", flexWrap: "wrap" }}
            >
              <div className="d-flex align-items-center gap-1 bg-primary badge rounded-pill">
                <div>{cell?.value?.[0]?.field?.title}</div>
              </div>
            </div>
          );
        },
      },

      {
        Header: t("applyStart"),
        accessor: "application_start_date",
        // filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },

      {
        Header: t("applyEnd"),
        accessor: "application_end_date",
        // filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("resultAnnounceDate"),
        accessor: "result_annc_date",
        // filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 150,
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("totalViewCount"),
        accessor: "total_view_count",
        // filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 150,
        Cell: (cell: any) => {
          return (
            <>
              <div
                className="cursor-pointer text-end"
                style={{ minWidth: "130px" }}
              >
                {cell?.value ?? "-"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("totalApplication"),
        accessor: "total_application_count",
        // filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            <>
              <div
                className="cursor-pointer text-end"
                style={{ minWidth: "130px" }}
              >
                {cell?.value ?? "-"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("lastApplicationDate"),
        accessor: "last_application_at",
        // filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },

      {
        Header: t("Button Action"),
        thClass: "align-middle text-center",
        thWidth: 120,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0 "
              style={{ width: "100px", justifyContent: "center" }}
            >
              {/* <TooltipCustom
                title={t("View Detail")}
                id={`view-md-${item?.id}`}
              >
                <li className="list-inline-item" id={`view-md-${item?.id}`}>
                  <Link
                    className="btn btn-sm btn-soft-primary edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToDetail(item);
                      setIsShowDetail(true);
                    }}
                  >
                    <i className="ri-eye-fill align-bottom "></i>
                  </Link>
                </li>
              </TooltipCustom> */}

              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom "></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    [i18n?.language, auditions?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  const onCloseQRCodeClick = () => {
    setPreviewQRCode(null);
  };

  // Begin::Delete
  const handleActionDelete = async (id: any) => {};

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    loadTableData();
  };

  const handleCloseModal = () => {
    setItemToDetail(null);

    if (!isShowDetail) {
      loadTableData();
    }
  };

  const initSummary = async () => {
    try {
      const res = await auditionApi.getSummary(query);
      setSummary(res?.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    loadTableData();
    initSummary();
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    dispatch(getCompanies({ limit: 1000 }));
    dispatch(getFields({ limit: 1000 }));
    document.title = `${t("Store")} | ShowStar`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Audition Management")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.ALL || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Draft")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.DRAFT || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Published")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.PUBLISHED || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Expired")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.EXPIRED || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Closed")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.CLOSED || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>

                    <div className="col-sm-auto text-end">
                      <button
                        type="button"
                        className="btn btn-success d-md-block"
                        onClick={() => {
                          setIsOpen(true);
                          setItemToEdit(null);
                        }}
                      >
                        <i className="ri-add-fill align-bottom me-1"></i>{" "}
                        {t("Button Create Audition")}
                      </button>
                    </div>
                  </div>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Title")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Title")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      {
                        userPermissions !== "COMPANY" && (
                          <Col
                            sm={12}
                            md={3}
                            xl={3}
                            xxl={3}
                            className="mt-3 mt-md-2"
                          >
                            <LabelWrapper label={t("Company")} isShow={true}>
                              <DropdownAsyncCompanies
                                name="company_id"
                                onChangeSelect={(event: any) => {
                                  setCompanySearch(event)
                                }}
                                isMulti={false}
                                placeholder={`${t("Select Company")}...`}
                                isShowIconCheck={false}
                                listCheckedUsers={companySearch}
                                isAllOption={true}
                                isClearable={false}
                              />
                            </LabelWrapper>
                          </Col>
                        )
                      }

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("fieldCategories")}
                          isShow={true}
                        >
                          <DropdownStatusNew
                            name="fieldSearch"
                            dataList={FIELDS}
                            placeholder={`${t("fieldCategories")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={fieldSearch}
                            onChangeSelect={(e: any) =>
                              setFieldSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("status")} isShow={true}>
                          <DropdownStatusNew
                            name="partner_status"
                            dataList={STATUS_ACTIVE_DISABLE_OPTION}
                            placeholder={`${t("Select status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={auditionStatusSearch}
                            onChangeSelect={(e: any) =>
                              setAuditionStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_ACTIVE_DISABLE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("auditionStatus")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_OPTION_AUDITION_STATUS}
                            placeholder={`${t("Select Auditon Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_AUDITION_STATUS}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!start_date || !!end_date}
                        >
                          <DatePickerCustom
                            startDate={start_date || null}
                            endDate={end_date || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={`${userPermissions !== "COMPANY" ? 6 : 9}`}
                        lg={`${userPermissions !== "COMPANY" ? 6 : 9}`}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={auditions?.items?.length ? auditions?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={auditions?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(auditions?.pagination?.total) /
                          Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isAuditionLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {isOpen && (
          <AuditionForm
            setIsOpen={setIsOpen}
            id={itemToEdit?.id}
            setItemToEdit={setItemToEdit}
            loadTableData={loadTableData}
            triggerRefresh={triggerRefresh}
            setLinkImage={setLinkImage}
          />
        )}

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Store Information")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {itemToDetail && (
          <Modal
            isOpen={!!itemToDetail}
            centered={true}
            size="xl"
            className="modal-fullscreen"
            scrollable={false}
          >
            <ModalHeader toggle={handleCloseModal}>
              {itemToDetail?.title || ""}
            </ModalHeader>
            <ModalBody>
              <BarListDetail
                barID={itemToDetail?.id}
                setLinkImage={setLinkImage}
                tabDetailActive={tabDetailActive}
              />
            </ModalBody>
          </Modal>
        )}

        {previewQRCode && (
          <ModalPreviewQRCode
            data={previewQRCode}
            title={""}
            onCloseQRCodeClick={onCloseQRCodeClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default AuditionManagement;
